var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4996,
    cy: 10.2526,
    r: 10.0504,
    fill: "#F91039"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4995 2.26172C6.08637 2.26172 2.50879 5.8393 2.50879 10.2524C2.50879 14.6656 6.08637 18.2432 10.4995 18.2432C14.9127 18.2432 18.4902 14.6656 18.4902 10.2524C18.4902 5.8393 14.9127 2.26172 10.4995 2.26172ZM10.4995 3.99798C13.9538 3.99798 16.753 6.79907 16.753 10.2524C16.753 13.7058 13.9538 16.5059 10.4995 16.5059C7.04526 16.5059 4.24603 13.7058 4.24603 10.2524C4.24604 6.79907 7.04526 3.99798 10.4995 3.99798Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4166 5.91602V9.28555L11.2294 11.8564H9.78171L9.58203 9.28555V5.91602H11.4166ZM10.7177 12.6925C10.959 12.6925 11.1254 12.7424 11.2169 12.8423C11.3167 12.9338 11.3666 13.1002 11.3666 13.3415V13.9405C11.3666 14.1901 11.3167 14.3607 11.2169 14.4522C11.1254 14.5437 10.959 14.5895 10.7177 14.5895H10.2934C10.0438 14.5895 9.87323 14.5437 9.78171 14.4522C9.69019 14.3607 9.64443 14.1901 9.64443 13.9405V13.3415C9.64443 13.1002 9.69019 12.9338 9.78171 12.8423C9.87323 12.7424 10.0438 12.6925 10.2934 12.6925H10.7177Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.71a46412e4bf7f5296b89a20ecf7b08e.svg";
export { ForwardRef as ReactComponent };